const styles = (theme) => ({
  tooltip: { maxWidth: "460px" },
  lista: { display: "flex", flexDirection: "column", gap: 1, py: 0.5 },
  linha: { display: "flex", alignItems: "center", gap: 1 },
  descricao: { fontSize: "12px" },
  icone: (cor) => ({
    color: theme?.palette?.cardGraphic?.graphColor?.[cor],
    cursor: "help",
  }),
});

export default styles;
